module.exports = "<button [disabled]=\"isBtnDisabled\" class=\"btn btn-default btn-lg\" (click)=\"copyToXero(invoiceId)\">\n    <i class=\"fi fa fa-files-o\"></i>Copy to Xero\n</button>"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/copy-to-xero-btn/copy-to-xero-btn.html
// module id = ./web/modern/components/buttons/copy-to-xero-btn/copy-to-xero-btn.html
// module chunks = 0